<div class="pb-5 px-md-5 mt-md-5">
  <h2 class="text-info mb-4 text-wrap-pretty" *ngIf="type == 'COMPANY'">Votre employeur a mis en place des aides pour vous aider à faire face à cette situation dont vous n'êtes pas responsable :</h2>
  <h2 class="text-info mb-4 text-wrap-pretty" *ngIf="type == 'COMMUNITY'">Votre ville a mis en place des aides pour vous aider à faire face à cette situation dont vous n'êtes pas responsable :</h2>
  <h2 class="text-info mb-4 text-wrap-pretty" *ngIf="type == 'CUSTOMER'">Les entreprises engagées avec Opale ont mis en place des aides pour vous aider à faire face à cette situation dont vous n'êtes pas responsable :</h2>
  <div class="row g-4">
    <div class="col-12 col-lg-4" *ngFor="let action of employers">
      <div class="card-resource">
        <p class="card-resource-text fw-semibold" [innerHTML]="replacePlaceVariable(action.content, action.variable)"></p>
        <ul class="card-resource-info" *ngIf="action.referent || action.email || action.phone">
          <li *ngIf="action.referent">
            <span class="material-icons">person</span>
            <span>{{action.referent}}</span>
          </li>
          <li *ngIf="action.email">
            <span class="material-icons">email</span>
            <span>{{action.email}}</span>
          </li>
          <li *ngIf="action.phone">
            <span class="material-icons">phone</span>
            <span>{{action.phone}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
